import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/dostavkee/_sidebar-layout/profile/')({
    onEnter: () => {
        document.title = 'Dostavkee - Профиль'
    },
})
